import React from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Strengths } from "@/components/Strengths";
import { Gallery } from "@/components/Gallery";
import { Services } from "@/components/Services";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { MobileStickyCTA } from "@/components/MobileStickyCTA";
import { ScrollProgress } from "@/components/ScrollProgress";

export default function Landing() {
  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="landing-page">
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <Strengths />
        <Gallery />
        <Services />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
      <MobileStickyCTA />
    </div>
  );
}
